import React from "react";

const DiamondFacialProcess = () => {
  return (
    <div className="organicFacialWhy">
      <h4>The Process of Diamond Glow Facial Services in Bangalore</h4>
      <ul>
        <li>
          <h6> 1. Consultation:</h6> Every session of Diamond Glow Facial
          Services in Bangalore at SCENT begins with a thorough consultation.
          Our skincare experts assess your skin type and concerns to tailor the
          treatment to your needs.
        </li>
        <li>
          <h6> 2. Cleansing:</h6> The treatment starts with a gentle yet
          thorough cleansing of the face to remove any impurities and makeup.
          This prepares your skin for the exfoliation process.
        </li>
        <li>
          <h6>3. Exfoliation:</h6> Using the diamond-tipped wand, we gently
          exfoliate the skin, removing dead skin cells and revealing fresher
          skin underneath. This step is crucial in our Diamond Glow Facial
          Services in Bangalore.
        </li>
        <li>
          <h6> 4. Extraction:</h6> The wand also performs painless extractions,
          clearing out clogged pores and reducing blackheads and whiteheads.
        </li>
        <li>
          <h6> 5. Infusion:</h6> Customized serums are infused into the skin
          during the treatment. These serums are selected based on your specific
          skin concerns, such as hydration, anti-aging, or brightening.
        </li>
        <li>
          <h6> 6. Hydration:</h6> A hydrating mask is applied to soothe and
          moisturize the skin, ensuring it remains plump and radiant.
        </li>
        <li>
          <h6>7. Protection:</h6> The final step involves applying a sunscreen
          to protect your newly rejuvenated skin from harmful UV rays.
        </li>
      </ul>
    </div>
  );
};

export default DiamondFacialProcess;
